export const discountByCountryCodes = [
  "ID", // Indonesia
  "AR", // Argentina
  "VN", // Vietnam
  "PH", // Philippines
  "TH", // Thailand
  "EG", // Egypt
  "TR", // Turkey
  "ZA", // South Africa
  "MY", // Malaysia
  "SA", // Saudi Arabia
  "PK", // Pakistan
  "NG", // Nigeria
  "CO", // Colombia
  "PE", // Peru
  "MA", // Morocco
  "CL", // Chile
  "AE", // United Arab Emirates
  "KW", // Kuwait
  "QA", // Qatar
  "JO", // Jordan
  "BD", // Bangladesh
  "GH", // Ghana
  "KE", // Kenya
  "TZ", // Tanzania
  "UG", // Uganda
  "ZM", // Zambia
  "ET", // Ethiopia
  "MM", // Myanmar
  "LK", // Sri Lanka
];

/**
 * List of countries where we can advertise without conflicting with partners
 */
export const partnerMarketingIncludeList = [
  // North America
  "US", // United States
  "CA", // Canada

  // Western & Northern Europe
  "GB", // United Kingdom
  "IE", // Ireland
  "FR", // France
  "DE", // Germany
  "NL", // Netherlands
  "BE", // Belgium
  "SE", // Sweden
  "NO", // Norway
  "DK", // Denmark
  "FI", // Finland
  "IS", // Iceland
  "ES", // Spain
  "PT", // Portugal
  "AT", // Austria
  "CH", // Switzerland
  "LU", // Luxembourg

  // Asia-Pacific exceptions
  "AU", // Australia
  "NZ", // New Zealand
  "JP", // Japan
  "PH", // Philippines

  //  Middle Eastern countries
  "AE", // United Arab Emirates
  "QA", // Qatar
  "SA", // Saudi Arabia
  "KW", // Kuwait
  "BH", // Bahrain
  "OM", // Oman

  // Africa
  "ZA", // South Africa

  // South America
  "CL", // Chile
  "UY", // Uruguay
];
